import React, { useState, useEffect } from 'react';
import { Trash2, Edit, Plus, X, Phone, Mail, Users, TrendingUp, DollarSign, AlertCircle, Eye, Lock, Shield, CheckCircle, XCircle, CreditCard } from 'lucide-react';
import './CommercialPage.css'; // Utilise le même CSS que la page commerciale
import Sidebar from '../components/Sidebar'; // ✅ استيراد صحيح

const handleLogout = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem('token');
  }
  window.location.href = '/';
};

const PaymentManagerPage = () => {
  const [managers, setManagers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [managerToDelete, setManagerToDelete] = useState(null);
  const [editingManager, setEditingManager] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [newManager, setNewManager] = useState({
    nom: '',
    telephone: '',
    email: '',
    motDePasse: '',
    confirmPassword: '',
    actif: true
  });

  // Get token from localStorage
  const token = typeof window !== 'undefined' ? window.localStorage?.getItem('token') : null;
  const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };

  const fetchManagers = async () => {
    try {
      const res = await fetch('    https://vmi1977988.contaboserver.net/api2/admin/paiement-managers', { headers });
      if (!res.ok) throw new Error('Erreur lors du chargement des gestionnaires');
      const data = await res.json();
      setManagers(data);
    } catch (error) {
      console.error('Erreur fetchManagers:', error);
      setError('Impossible de charger les gestionnaires de paiement');
    }
  };

  const validateForm = () => {
    if (!newManager.nom.trim()) {
      setError('Le nom est requis');
      return false;
    }
    if (!newManager.email.trim()) {
      setError('L\'email est requis');
      return false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newManager.email)) {
      setError('Format d\'email invalide');
      return false;
    }

    if (!newManager.telephone.trim()) {
      setError('Le téléphone est requis');
      return false;
    }

    // Validation du mot de passe pour les nouveaux managers
    if (!editingManager && !newManager.motDePasse) {
      setError('Le mot de passe est requis');
      return false;
    }

    // Vérification de la confirmation du mot de passe
    if (newManager.motDePasse && newManager.motDePasse !== newManager.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return false;
    }

    // Validation de la force du mot de passe
    if (newManager.motDePasse && newManager.motDePasse.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return false;
    }

    return true;
  };

  const handleCreateOrUpdateManager = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const url = editingManager
        ? `     https://vmi1977988.contaboserver.net/api2/admin/paiement-managers/${editingManager._id}`
        : '    https://vmi1977988.contaboserver.net/api2/admin/paiement-managers';

      const method = editingManager ? 'PUT' : 'POST';

      // Préparer les données à envoyer
      const dataToSend = {
        nom: newManager.nom,
        telephone: newManager.telephone,
        email: newManager.email,
        actif: newManager.actif
      };

      // Inclure le mot de passe seulement s'il est fourni
      if (newManager.motDePasse) {
        dataToSend.motDePasse = newManager.motDePasse;
      }

      const res = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(dataToSend)
      });

      if (res.ok) {
        resetForm();
        await fetchManagers();
        setShowModal(false);
        setError('');
      } else {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Erreur lors de la sauvegarde');
      }
    } catch (error) {
      console.error('Erreur création/modification manager:', error);
      setError(error.message || 'Impossible de sauvegarder le gestionnaire');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteManager = async () => {
    if (!managerToDelete) return;

    setLoading(true);
    try {
      const res = await fetch(`     https://vmi1977988.contaboserver.net/api2/admin/paiement-managers/${managerToDelete._id}`, {
        method: 'DELETE',
        headers
      });

      if (res.ok) {
        await fetchManagers();
        setShowDeleteModal(false);
        setManagerToDelete(null);
        setError('');
      } else {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Erreur lors de la suppression');
      }
    } catch (error) {
      console.error('Erreur suppression manager:', error);
      setError('Impossible de supprimer le gestionnaire');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActive = async (manager) => {
    try {
      setLoading(true);
      const res = await fetch(`     https://vmi1977988.contaboserver.net/api2/admin/paiement-managers/${manager._id}/toggle-active`, {
        method: 'PATCH',
        headers
      });

      if (res.ok) {
        await fetchManagers();
        setError('');
      } else {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Erreur lors de la modification du statut');
      }
    } catch (error) {
      console.error('Erreur toggle actif:', error);
      setError('Impossible de modifier le statut');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setNewManager({
      nom: '',
      telephone: '',
      email: '',
      motDePasse: '',
      confirmPassword: '',
      actif: true
    });
    setEditingManager(null);
    setShowPassword(false);
    setError('');
  };

  const openEditModal = (manager) => {
    setEditingManager(manager);
    setNewManager({
      nom: manager.nom || '',
      telephone: manager.telephone || '',
      email: manager.email || '',
      motDePasse: '',
      confirmPassword: '',
      actif: manager.actif !== false
    });
    setShowModal(true);
  };

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  useEffect(() => {
    fetchManagers();
  }, []);

  return (
    <div className="commercial-page">
      <Sidebar onLogout={handleLogout} />

      <div className="container">
        {/* Header */}
        <div className="header-card">
          <div className="header-content">
            <div className="header-info">
              <h1 className="page-title">Gestion des Managers de Paiement</h1>
            </div>
            <button className="btn btn-primary" onClick={openAddModal}>
              <Plus size={20} />
              Nouveau Manager
            </button>
          </div>
        </div>

        {/* Error Message */}
        {error && (
          <div className="error-message">
            <AlertCircle size={20} />
            {error}
            <button
              onClick={() => setError('')}
              className="btn-close"
              style={{ marginLeft: 'auto' }}
            >
              <X size={16} />
            </button>
          </div>
        )}

        {/* Managers List */}
        <div className="commercials-card">
          <h2 className="section-title">
            <CreditCard size={24} className="icon-green" />
            Gestionnaires de Paiement ({managers.length})
          </h2>

          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Chargement des gestionnaires...</p>
            </div>
          ) : (
            <div className="commercials-grid">
              {managers.map(manager => (
                <div key={manager._id} className="commercial-item">
                  <div className="commercial-header">
                    <h3 className="commercial-name">{manager.nom}</h3>
                    <div className="commercial-actions">
                      <button
                        onClick={() => handleToggleActive(manager)}
                        className={`badge ${manager.actif ? 'green-badge' : 'red-badge'}`}
                        title={`Cliquer pour ${manager.actif ? 'désactiver' : 'activer'}`}
                        style={{
                          cursor: 'pointer',
                          border: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.25rem'
                        }}
                      >
                        {manager.actif ? (
                          <>
                            <CheckCircle size={12} />
                            Actif
                          </>
                        ) : (
                          <>
                            <XCircle size={12} />
                            Inactif
                          </>
                        )}
                      </button>
                      <button
                        onClick={() => openEditModal(manager)}
                        className="btn-icon yellow"
                        title="Modifier"
                      >
                        <Edit size={16} />
                      </button>
                      <button
                        onClick={() => {
                          setManagerToDelete(manager);
                          setShowDeleteModal(true);
                        }}
                        className="btn-icon red"
                        title="Supprimer"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>

                  <div className="commercial-details">
                    {manager.telephone && (
                      <div className="detail-item">
                        <Phone size={14} />
                        {manager.telephone}
                      </div>
                    )}
                    {manager.email && (
                      <div className="detail-item">
                        <Mail size={14} />
                        {manager.email}
                      </div>
                    )}
                    <div className="detail-small">
                      Créé le {new Date(manager.createdAt).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {managers.length === 0 && !loading && (
            <div className="no-students">
              <CreditCard size={48} />
              <p>Aucun gestionnaire de paiement trouvé</p>
              <button className="btn btn-primary" onClick={openAddModal}>
                Créer le premier gestionnaire
              </button>
            </div>
          )}
        </div>

        {/* Modal for Add/Edit Manager */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h3 className="modal-title">
                  {editingManager ? 'Modifier Manager' : 'Nouveau Manager'}
                </h3>
                <button
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="btn-close"
                >
                  <X size={24} />
                </button>
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <label>Nom complet *</label>
                  <input
                    type="text"
                    value={newManager.nom}
                    onChange={e => setNewManager({ ...newManager, nom: e.target.value })}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Téléphone *</label>
                  <input
                    type="tel"
                    value={newManager.telephone}
                    onChange={e => setNewManager({ ...newManager, telephone: e.target.value })}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    value={newManager.email}
                    onChange={e => setNewManager({ ...newManager, email: e.target.value })}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    {editingManager ? 'Nouveau mot de passe (laisser vide pour ne pas changer)' : 'Mot de passe *'}
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={newManager.motDePasse}
                      onChange={e => setNewManager({ ...newManager, motDePasse: e.target.value })}
                      required={!editingManager}
                      placeholder={editingManager ? "Nouveau mot de passe..." : "Mot de passe..."}
                      style={{ paddingRight: '40px' }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#6b7280'
                      }}
                    >
                      <Eye size={16} />
                    </button>
                  </div>
                </div>

                {newManager.motDePasse && (
                  <div className="form-group">
                    <label>Confirmer le mot de passe *</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={newManager.confirmPassword}
                      onChange={e => setNewManager({ ...newManager, confirmPassword: e.target.value })}
                      placeholder="Confirmer le mot de passe..."
                    />
                  </div>
                )}

                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <input
                      type="checkbox"
                      checked={newManager.actif}
                      onChange={e => setNewManager({ ...newManager, actif: e.target.checked })}
                    />
                    <CheckCircle size={16} />
                    Compte actif
                  </label>
                </div>

                <div className="modal-actions">
                  <button
                    onClick={handleCreateOrUpdateManager}
                    disabled={loading}
                    className="btn btn-primary"
                  >
                    {loading ? 'Sauvegarde...' : editingManager ? 'Modifier' : 'Ajouter'}
                  </button>
                  <button
                    onClick={() => {
                      setShowModal(false);
                      resetForm();
                    }}
                    className="btn btn-secondary"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteModal && managerToDelete && (
          <div className="modal-overlay">
            <div className="modal small">
              <div className="modal-header">
                <h3 className="modal-title">Confirmer la suppression</h3>
              </div>
              <div className="modal-body">
                <p className="modal-text">
                  Êtes-vous sûr de vouloir supprimer le gestionnaire <strong>{managerToDelete.nom}</strong> ?
                  Cette action est irréversible.
                </p>
                <div className="modal-actions">
                  <button
                    onClick={handleDeleteManager}
                    disabled={loading}
                    className="btn btn-danger"
                  >
                    {loading ? 'Suppression...' : 'Supprimer'}
                  </button>
                  <button
                    onClick={() => {
                      setShowDeleteModal(false);
                      setManagerToDelete(null);
                    }}
                    className="btn btn-secondary"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentManagerPage;